import React from 'react';
import { useChat } from '../../context/ChatContext';
import Button from '../common/Button';
import Loading from '../common/Loading';

const ConversationList = ({ onSelectConversation, currentId }) => {
  const {
    conversations,
    loading,
    error,
    createConversation,
    deleteConversation,
  } = useChat();

  const handleCreateConversation = async () => {
    const newConversationId = await createConversation();
    if (newConversationId) {
      onSelectConversation(newConversationId);
    }
  };

  const handleDeleteConversation = async (id, e) => {
    e.stopPropagation();
    if (window.confirm('Are you sure you want to delete this conversation?')) {
      await deleteConversation(id);
    }
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const now = new Date();
    const isToday =
      date.getDate() === now.getDate() &&
      date.getMonth() === now.getMonth() &&
      date.getFullYear() === now.getFullYear();

    if (isToday) {
      return date.toLocaleTimeString([], {
        hour: '2-digit',
        minute: '2-digit',
      });
    }

    return date.toLocaleDateString([], {
      month: 'short',
      day: 'numeric',
    });
  };

  if (loading && conversations.length === 0) {
    return <Loading text="Loading conversations..." />;
  }

  if (error) {
    return (
      <div className="p-4 text-red-700 bg-red-100 rounded-md">
        {error}. Please try refreshing the page.
      </div>
    );
  }

  return (
    <div className="h-full flex flex-col">
      <div className="p-4">
        <Button
          onClick={handleCreateConversation}
          className="w-full"
          disabled={loading}
        >
          New Conversation
        </Button>
      </div>

      <div className="flex-1 overflow-y-auto">
        {conversations.length === 0 ? (
          <div className="p-4 text-center text-gray-500">
            No conversations yet. Start by creating a new one.
          </div>
        ) : (
          <ul className="space-y-1">
            {conversations.map((conversation) => (
              <li
                key={conversation.id}
                className={`p-2 m-2 rounded-md cursor-pointer hover:bg-gray-100 flex justify-between ${
                  currentId === conversation.id ? 'bg-primary-100' : ''
                }`}
                onClick={() => onSelectConversation(conversation.id)}
              >
                <div className="flex-1 overflow-hidden">
                  <p className="font-medium truncate">{conversation.title}</p>
                  <p className="text-xs text-gray-500">
                    {formatDate(conversation.updated_at)}
                  </p>
                </div>
                <button
                  onClick={(e) => handleDeleteConversation(conversation.id, e)}
                  className="text-gray-400 hover:text-red-600 p-1"
                  title="Delete conversation"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="h-4 w-4"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
                    />
                  </svg>
                </button>
              </li>
            ))}
          </ul>
        )}
      </div>
    </div>
  );
};

export default ConversationList;